import { analytics } from '@/features/analytics/events'
import { isCaptchaFailedError } from '@/features/turnstile'
import { t } from '@lingui/core/macro'
import { toast } from 'sonner'
import { useSubmitNectarTask } from '../api'
import type { AudioTranscriptionSegment } from '../api/models'
import { CaptchaOptions } from './useSubmitAudioAnnotation'

type SubmitArgs = {
  projectId: string
  taskId: string
  taskIndex: number
  segments?: AudioTranscriptionSegment[]
  answers?: Record<string, unknown>
  onSuccess?: () => void
  onError?: () => void
}

export const useSubmitAudioTranscription = ({ captcha }: CaptchaOptions) => {
  const { mutateAsync: submitTask, isPending } = useSubmitNectarTask()

  const submit = async ({ projectId, taskId, taskIndex, segments, onSuccess, onError }: SubmitArgs) => {
    try {
      const data: Record<string, unknown> = {}
      if (segments) data.segments = segments
      await submitTask({
        projectId,
        taskId,
        data,
        turnstileToken: captcha.token ?? undefined
      })
      captcha.reset()
      toast.success(t`Submitted!`)
      analytics.missionTaskSubmitted(projectId, taskId, taskIndex)
      onSuccess?.()
    } catch (err) {
      captcha.reset()
      if (isCaptchaFailedError(err)) {
        toast.error(t`Verification failed. Please try again.`)
      } else {
        toast.error(t`Failed to submit`)
      }
      onError?.()
    }
  }

  return { submit, isSubmitting: isPending }
}
